import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { Customer } from '../models/customer.model';
import { Observable } from 'rxjs';
import { Horse } from '../models/horse.model';
import { Address } from '../models/address.model';

export class CustomerEndpoint {

  constructor(private apiService: APIServiceService) {}
  endpoint = 'customers/';

  async create(customer: Customer): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint, token, customer).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async patch(customerID: number, detailsToUpdate: any): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + 'patch/' + customerID, token, detailsToUpdate).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async update(customer: Customer): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + customer.id, token, customer).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async delete(customerId: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doDELETE(this.endpoint + customerId, token).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async deleteAddress(customerId: number, addressId: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doDELETE(this.endpoint + customerId + '/address/' + addressId, token).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async list(page?: number, size?: number, sortField?: string, sortOrder?: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + 'list', token, { page, size, sortField, sortOrder }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async search(term: string, page: number = 0, size: number = 10): Promise<{ success: boolean, data: { total: number, results: Customer[] } }> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + 'search', token, { term, page, size }).toPromise();
      if (response.success) {
        response.data.results = response.data.results.map(c => new Customer().deserialize(c));
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getByID(id: number, includeHorses: boolean = false): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + id, token, { includeHorses }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getHorses(customerId: number): Promise<{ success: boolean, data: { results: Horse[] } }> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + customerId + '/horses', token, null).toPromise();
      if (response.success) {
        response.data.results = response.data.results.map(result => new Horse().deserialize(result));
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getProvisionalHorses(customerId: number, bookingId: string): Promise<{ success: boolean, data: { results: Horse[] } }> {
    try {
      const token = await this.apiService.getCurrentApptDetailsToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + customerId + "/" + bookingId + '/provisional/horses', token, {}).toPromise();
      if (response.success) {
        response.data.results = response.data.results.map(result => new Horse().deserialize(result));
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getAddresses(customerId: number): Promise<{ success: boolean, data: { results: Address[] } }> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + customerId + '/addresses', token, null).toPromise();
      if (response.success) {
        response.data.results = response.data.results.map(result => new Address().deserialize(result));
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async isEmailtaken(email: string): Promise<any> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + '/email', token, { email }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async reindex(): Promise<any> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + '/reindex', token, { }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
}
